export default ({ request }) => ({
  // Create subscription
  create_subscription(data) {
    return request({
      url: '/v1/subscriptions',
      method: 'post',
      data: data
    })
  },

  // Get subscription detail
  get_subscription_detail(id) {
    return request({
      url: `/v1/subscriptions/${id}`,
      method: 'get'
    })
  },

  // Get subscriptions by tenant ID
  get_subscriptions_by_tenant(tenantId, params) {
    return request({
      url: `/v1/subscriptions/tenant/${tenantId}`,
      method: 'get',
      params: params
    })
  },

  // Update subscription
  update_subscription(id, data) {
    return request({
      url: `/v1/subscriptions/${id}`,
      method: 'put',
      data: data
    })
  },

  // Delete subscription
  delete_subscription(id) {
    return request({
      url: `/v1/subscriptions/${id}`,
      method: 'delete'
    })
  },

  // Get tenant subscription status
  get_tenant_subscription_status(tenantId) {
    return request({
      url: `/v1/subscriptions/status/${tenantId}`,
      method: 'get'
    })
  }
})
